import { Link } from 'react-router-dom';
import { categories, manhwaList } from '@/mocks/manhwa';

const catIcons: Record<string, string> = {
  urban: 'ri-building-2-line',
  fantasy: 'ri-sparkling-2-line',
  romance: 'ri-heart-3-line',
  action: 'ri-sword-line',
  thriller: 'ri-ghost-line',
  rebirth: 'ri-time-line',
  healing: 'ri-sun-line',
};

export default function Genres() {
  return (
    <section id="genres" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-layout-grid-fill" /> 分类导航
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">按题材挑你的韩漫</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            想找什么类型的韩漫？按题材分类快速进入，找到合你口味的作品。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const count = manhwaList.filter((m) => m.category === cat.id).length;
            const samples = manhwaList.filter((m) => m.category === cat.id).slice(0, 3);
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${catIcons[cat.id] ?? 'ri-book-2-line'} text-xl`} />
                  </span>
                  <span className="rounded-full bg-background-200 px-2.5 py-1 text-xs text-foreground-600">{count} 部</span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                <p className="mt-1 text-xs font-medium text-primary-600">{cat.tagline}</p>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{cat.desc}</p>
                <div className="mt-4 flex items-center gap-2">
                  {samples.map((m) => (
                    <div key={m.id} className="h-14 w-11 overflow-hidden rounded-md bg-background-200">
                      <img
                        src={m.cover}
                        alt={m.title}
                        title={`${m.title} ${cat.name}韩漫`}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                  ))}
                  <span className="ml-auto inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700">
                    查看书单 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}